export const EMAIL_REGEX = /\b[\w.-]+(?:\+\w+)?@[\w-]+(?:\.[\w-]+)+\b/g

export const getEmailsListFromString = (string = '') => {
  return string.match(EMAIL_REGEX) || []
}

export const isEmailString = ({ string = '' } = {}) => {
  return new RegExp(EMAIL_REGEX).test(string)
}
